export const DAILY_CLOSE_HEADS_URL = '/api/v1/get-daily-close-heads'
export const DAILY_CLOSE_HEADS_EXCEL_URL = `${DAILY_CLOSE_HEADS_URL}/excel`
export const DAILY_CLOSE_ITEMS_URL = '/api/v1/get-daily-close-items'
export const DAILY_CLOSE_ITEMS_EXCEL_URL = `${DAILY_CLOSE_ITEMS_URL}/excel`
